<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormCategory
          @submit="fromCategorySubmit"
          :data="eventCategory"
          :loading="isFormLoading"
          @delete-category="deleteCategory"
          :isNew="!id"
          :language="language"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmEventRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormCategory from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import createEventCategory from '@/services/gql/types/EventCategory/mutations/createEventCategory.gql'
import deleteEventCategory from '@/services/gql/types/EventCategory/mutations/deleteEventCategory.gql'
import updateEventCategory from '@/services/gql/types/EventCategory/mutations/updateEventCategory.gql'
import eventCategory from '@/services/gql/types/EventCategory/queries/eventCategory.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'
export default {
  name: 'PageCategory',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    FormCategory,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать категорию' : 'Создать категорию'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      isError: false,
      errorText: '',
      eventCategory: {}
    }
  },
  computed: {
    isFormLoading () {
      return (
        this.$apollo.queries.eventCategory.loading ||
        this.$async.createCategory.$pending ||
        this.$async.updateCategory.$pending
      )
    },
    context () {
      return this
    }
  },
  methods: {
    async fromCategorySubmit (category) {
      if (!this.id) await this.createCategory(category)
      else await this.updateCategory(category)
    },
    async deleteCategory () {
      try {
        await this.$refs.confirmEventRemoving.open()
        await this.$async.deleteCategory.$perform({ deleteEventCategoryId: Number(this.id) })
        this.$successMsg('Категория удалена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении категории с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-categories' })
      }
    },
    async updateCategory (data) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateCategory.$perform({
          updateEventCategoryId: Number(this.id),
          data
        }, { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) })
        this.$successMsg('Категория изменена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при редактировании категории')
      }
    },
    async createCategory (data) {
      try {
        delete data.translations
        await this.$async.createCategory.$perform({ data })
        this.$successMsg('Категория создана')
        await this.$router.push({ name: 'page-categories' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании категории')
      }
    }
  },
  apollo: {
    eventCategory: {
      query: eventCategory,
      fetchPolicy: 'network-only',
      skip () { return !this.id },
      variables () { return { where: { id: Number(this.id) } } },
      context () { return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } } }
    }
  },
  async: {
    createCategory (variables) {
      return this.$apollo.mutate({
        mutation: createEventCategory,
        variables
      })
    },
    deleteCategory (variables) {
      return this.$apollo.mutate({
        mutation: deleteEventCategory,
        variables
      })
    },
    updateCategory (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateEventCategory,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
